/**
 * Boots the auth session after persistence hydration (proactive / silent refresh).
 */

import React, { useEffect, useRef } from "react";
import { bootstrapAuthSession } from "../services/auth";
import { usePersistenceReady } from "../store/persistence";

/**
 * Side-effect component that schedules access-token refresh after boot.
 *
 * @returns `null` (no UI).
 */
export const AuthBootstrap: React.FC = () => {
    const persistenceReady = usePersistenceReady();
    const startedRef = useRef( false );

    useEffect( () => {
        if ( !persistenceReady || startedRef.current ) {
            return;
        }
        startedRef.current = true;
        void bootstrapAuthSession();
    }, [ persistenceReady ] );

    return null;
};
